<template>
  <div class="relative group/subitem sm:hover:bg-[#F6F6F6]">
    <component
      :is="tag"
      v-bind="linkProps"
      :class="[
        'navitem block py-2 sm:mx-4 sm:py-3 group-hover/subitem:text-jva-blue-500 group-hover/subitem:!border-transparent ',
        { 'text-jva-blue-500 sm:bg-[#F6F6F6] font-medium': item.isActive },
      ]"
    >
      {{ item.name }}
    </component>
  </div>
</template>

<script setup>
import { NuxtLink } from '#components'
import { computed } from 'vue'

const props = defineProps({
  item: Object,
})

const tag = computed(() => {
  if (props.item.as === 'button') return 'button'
  if (props.item.as === 'a') return 'a'
  return NuxtLink
})

const linkProps = computed(() => {
  return {
    ...(props.item.to ? { to: props.item.to, target: props.item.target } : {}),
    ...(props.item.href ? { href: props.item.href, target: props.item.target } : {}),
  }
})
</script>
